import loadable from '@loadable/component'

export const RatingHistDisclosure = loadable(
  () => import('./RatingHistDisclosure')
)
export type { ratingHistProps } from './RatingHistDisclosure'
